import
  React
from 'react';

import
  styled
from 'styled-components';

import
  Select
from 'react-select';

import
  PropTypes
from 'prop-types';

import {
  HContainerV,
  Image,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

const Input = styled.input`
  font-size: ${props => props.fontSize};
  color: ${props => props.inputColor};
  font-family: ${props => props.fontFamily};
  border: none;
  outline: none;

  &:focus {
    border: none;
  }

  &::placeholder {
    color: ${CustomColors.Grey6};
    font-size: '16px';
  }
`;

const InputContainer = styled.div`
  padding: ${props => props.padding};
  width: ${props => props.width};
  border: solid 0.6px ${props => props.borderColor};
  border-radius: ${props => props.borderRadius};
  margin: ${props => props.margin};
  box-sizing: border-box;

  &:focus-within {
    border-color: ${CustomColors.Black};
  }
`;

export const FormInput = (props) => {

  const dropdownStyles = {
    control: (styles, state) => ({
      ...styles,
      fontSize: props.inputFontSize,
      borderColor:
        state.isFocused
          ? CustomColors.Black
          : props.isValid !== false
            ? props.borderColor
            : props.invalidInputColor,
      padding: '8px',
      boxShadow: 'none'
    })
  };

  const [ input, setInput ] = React.useState({
    value: undefined
  });

  const handleChange = (e) => {

    if (props.type === 'select') {
      handleBlur({ target: {
        name: props.name,
        value: e.value
      } });

      return;
    }

    const target = e.target;
    const value =
      props.type === 'checkbox'
        ? target.checked
        : target.value;

    setInput(prevInput => ({
      ...prevInput,
      value: value
    }));
  };

  const handleBlur = (e) => {

    props.onBlur(e);
  };

  const handleNumberInput = (e) => {

    if (props.type !== 'number') {

      return;
    }

    const invalidInput = [ '-', '+', 'e', 'E', 187, 69, 189 ];
    const isValid =
      invalidInput
        ?.filter(invalid => invalid === e?.key || invalid === e?.keyCode)
        .length === 0;

    if (!isValid) {
      e.preventDefault();
    }
  };

  return (

    <>
    {
      !props.hidden &&
      <VContainer
        margin={props.margin}>

        <Text
          color={props.labelColor}
          fontWeight={props.labelWeight}
          fontSize={props.labelFontSize}>

            {props.label}
        </Text>

        <VContainer
          margin={'4px 0'}/>

      {
        props.type === 'select'
          ? <Select
              name={props.name}
              options={props.options}
              onChange={handleChange}
              placeholder={'Start typing...'}
              noOptionsMessage={() => 'No results'}
              styles={dropdownStyles} />

          : <InputContainer
              padding={props.padding}
              borderColor={
                props.isValid !== false
                ? props.borderColor
                : props.invalidInputColor
              }
              borderRadius={props.borderRadius}
              onKeyDown={handleNumberInput}
              width={props.width}>

              <Input
                type={props.type}
                name={props.name}
                fontSize={props.inputFontSize}
                fontFamily={props.inputFontFamily}
                fontWeight={props.inputFontWeight}
                value={input.value || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={props.placeholder}/>

            </InputContainer>
      }
      {
        !props.isValid &&
        <HContainerV
          margin={'8px 0 0'}>

          <Image
            src={Icons.ErrorSmall}
            width={'16px'}
            height={'16px'} />

          <Text
            fontSize={props.invalidInputSize}
            fontWeight={props.invalidInputWeight}
            padding={'0 0 0 4px'}
            color={props.invalidInputColor}>

              {props.invalidInputText}
          </Text>
        </HContainerV>
      }
      </VContainer>
    }
    </>
  );
};

FormInput.propTypes = {
  margin: PropTypes.string,
  width: PropTypes.string,
  borderColor: PropTypes.string,
  borderRadius: PropTypes.string,
  padding: PropTypes.string,
  hidden: PropTypes.bool,
  placeholder: PropTypes.string,
  inputFontSize: PropTypes.string,
  inputColor: PropTypes.string,
  inputWeight: PropTypes.string,
  label: PropTypes.string,
  labelFontSize: PropTypes.string,
  labelColor: PropTypes.string,
  labelWeight: PropTypes.string,
  invalidInputText: PropTypes.string,
  invalidInputSize: PropTypes.string,
  invalidInputWeight: PropTypes.string,
  invalidInputColor: PropTypes.string,
  type: PropTypes.string,
  fontFamily: PropTypes.string
};

FormInput.defaultProps = {
  margin: '0 0 24px',
  width: '100%',
  borderColor: CustomColors.Grey4,
  borderRadius: '4px',
  padding: '16px',
  hidden: false,
  placeholder: 'placeholder',
  inputFontSize: '16px',
  inputColor: CustomColors.Grey5,
  inputWeight: '500',
  label: 'label',
  labelFontSize: '16px',
  labelColor: CustomColors.Grey11,
  labelWeight: '500',
  invalidInputText: 'Invalid text',
  invalidInputSize: '12px',
  invalidInputColor: CustomColors.Red1,
  invalidInputWeight: '500',
  type: 'text',
  fontFamily: 'Roboto'
};